/* @flow */

export type ContentTypeSystem = {
  id: string,
  name: string,
  codename: string,
  language: string,
  type: string,
  sitemapLocations: string[],
  lastModified: string,
};
export class ContentType {
  static typeName: string = 'default';

  system: ContentTypeSystem;

  constructor(data: Object, _modularData?: Object) {
    if (data.system) {
      this.system = {
        id: data.system.id,
        name: data.system.name,
        codename: data.system.codename,
        language: data.system.language,
        type: data.system.type,
        sitemapLocations: data.system.sitemap_locations,
        lastModified: data.system.last_modified,
      };
    }
  }
}
